import i18n from '@/lang';
/* unplugin-vue-components disabled */
import { Button as __unplugin_components_10 } from 'vant/es';
import 'vant/es/button/style/index';
import { Button as __unplugin_components_9 } from 'vant/es';
import 'vant/es/button/style/index';
import { Button as __unplugin_components_8 } from 'vant/es';
import 'vant/es/button/style/index';
import { Button as __unplugin_components_7 } from 'vant/es';
import 'vant/es/button/style/index';
import { Button as __unplugin_components_6 } from 'vant/es';
import 'vant/es/button/style/index';
import { Button as __unplugin_components_5 } from 'vant/es';
import 'vant/es/button/style/index';
import { Button as __unplugin_components_4 } from 'vant/es';
import 'vant/es/button/style/index';
import { Button as __unplugin_components_3 } from 'vant/es';
import 'vant/es/button/style/index';
import { Card as __unplugin_components_2 } from 'vant/es';
import 'vant/es/card/style/index';
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Base/SinglePicker.vue';
import { CellGroup as __unplugin_components_0 } from 'vant/es';
import 'vant/es/cell-group/style/index';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "determineOrder"
  }, [_c('div', {
    staticClass: "connect"
  }, [_c(__unplugin_components_0, {
    staticClass: "connect-box",
    attrs: {
      "inset": ""
    }
  }, [_c('div', {
    staticClass: "orderCont"
  }, [_c('p', [_vm._v(_vm._s(_vm.state))]), _vm.from.courier_number ? _c('div', {
    staticClass: "shipmentNumber"
  }, [_c('span', [_vm._v(_vm._s(_vm.from.courier_number || ' '))]), _c('span', {
    staticClass: "copy",
    on: {
      "click": function ($event) {
        return _vm.copy();
      }
    }
  }, [_vm._v(i18n.tc("255"))])]) : _vm._e()])])], 1), _c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "flex-address"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/MH3.9/dingwei.png"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "info"
  }, [_c('p', {
    staticClass: "adres"
  }, [_vm._v(_vm._s(_vm.from.receiving_address + " " + _vm.from.detail_addr))]), _c('div', {
    staticClass: "linkperson"
  }, [_c('span', [_vm._v(_vm._s(_vm.from.linkperson))]), _c('span', [_vm._v(_vm._s(_vm.from.linkperson_phone))])])])]), !_vm.from.pay_state && _vm.from.pay_method == 2 ? _c(__unplugin_components_1, {
    attrs: {
      "title": i18n.tc("256"),
      "data": _vm.columns,
      "format": function (v) {
        return {
          name: v.name,
          value: String(v.id)
        };
      }
    },
    model: {
      value: _vm.payId,
      callback: function ($$v) {
        _vm.payId = $$v;
      },
      expression: "payId"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "product"
  }, _vm._l(_vm.orderData, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "commodityBox"
    }, [_c('div', {
      staticClass: "orderState"
    }, [_c('span', [_vm._v(_vm._s(item.order_number))]), _c('span', {
      staticClass: "state"
    }, [_vm._v(_vm._s(_vm.orderStatus.find(function (v) {
      return v.order_type == item.order_type;
    })))])]), _c(__unplugin_components_2, {
      attrs: {
        "num": item.goods_num,
        "title": item.goods_name,
        "thumb": item.goods_image
      },
      scopedSlots: _vm._u([{
        key: "price",
        fn: function () {
          return [_c('span', {
            staticClass: "price-text"
          }, [_vm._v("￥" + _vm._s(item.goodst_price))])];
        },
        proxy: true
      }, {
        key: "footer",
        fn: function () {
          return [_c('div', {
            staticClass: "mb-10 mt-10"
          }, [_c('span', [_vm._v(i18n.tc("250"))]), _c('span', [_vm._v(_vm._s(item.goods_amount))])]), item.useflag ? _c('div', [_c(__unplugin_components_3, {
            attrs: {
              "round": "",
              "size": "small",
              "type": "primary"
            },
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                return _vm.goBook(item);
              }
            }
          }, [_vm._v(i18n.tc("251"))])], 1) : _vm._e()];
        },
        proxy: true
      }], null, true)
    })], 1);
  }), 0), _c('div', {
    staticClass: "paymentInformation"
  }, [_c('h1', [_vm._v(i18n.tc("257"))]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v(i18n.tc("258"))]), _c('span', [_vm._v(_vm._s(_vm.from.order_number))])]), _c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v(i18n.tc("256"))]), _c('span', [_vm._v(_vm._s(_vm.from.pay_method == 1 ? i18n.tc("161") : i18n.tc("249")))])]), _c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v(i18n.tc("259"))]), _c('span', [_vm._v(_vm._s(_vm.from.create_time))])]), _c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v(i18n.tc("260"))]), _c('span', [_vm._v(_vm._s(_vm.from.delivery_method == 1 ? i18n.tc("261") : ''))])]), _c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v(i18n.tc("262"))]), _c('span', [_vm._v(_vm._s(_vm.from.freight_cost == 1 ? i18n.tc("263") : ''))])]), _c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v(i18n.tc("264"))]), _c('span', [_vm._v(_vm._s(_vm.from.invoice_title ? _vm.from.invoice_title : '-'))])]), _c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v(i18n.tc("265"))]), _c('span', {
    staticClass: "invoiceAddress"
  }, [_vm._v(" " + _vm._s(_vm.from.invoice_mailing_address + " " + _vm.from.detail_address) + " ")])]), _c('div', {
    staticClass: "box"
  }, [_c('span', [_vm._v(i18n.tc("266"))]), _c('span', [_vm._v(_vm._s(_vm.from.create_remark ? _vm.from.create_remark : '-'))])])])]), _c('div', {
    staticClass: "bottom"
  }, [_c(__unplugin_components_4, {
    staticClass: "btn",
    attrs: {
      "size": "small",
      "round": "",
      "type": "primary"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.goBookRecord.apply(null, arguments);
      }
    }
  }, [_vm._v(i18n.tc("267"))]), _vm.from.order_type == 1 ? _c(__unplugin_components_5, {
    staticClass: "btn",
    attrs: {
      "size": "small",
      "round": "",
      "type": "warning"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.calOrder.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + i18n.tc("268") + " ")]) : _vm._e(), _vm.from.order_type == 1 && _vm.from.pay_method === 1 ? _c(__unplugin_components_6, {
    staticClass: "btn",
    attrs: {
      "size": "small",
      "round": "",
      "type": "primary"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.fillIn.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + i18n.tc("269") + " ")]) : _vm._e(), _vm.from.order_type == 1 && _vm.from.pay_method === 2 ? _c(__unplugin_components_7, {
    staticClass: "btn",
    attrs: {
      "size": "small",
      "round": "",
      "type": "primary"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.payOrder.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + i18n.tc("270") + " ")]) : _vm._e(), _vm.from.order_type == 4 || _vm.from.order_type == 3 || _vm.from.order_type == 2 ? _c(__unplugin_components_8, {
    staticClass: "btn",
    attrs: {
      "size": "small",
      "round": "",
      "type": "primary"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.goInformation.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + i18n.tc("271") + " ")]) : _vm._e(), _vm.from.order_type == 4 ? _c(__unplugin_components_9, {
    staticClass: "btn",
    attrs: {
      "size": "small",
      "round": "",
      "type": "primary"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.confirm.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + i18n.tc("272") + " ")]) : _vm._e(), _vm.from.order_type == 5 ? _c(__unplugin_components_10, {
    staticClass: "btn",
    attrs: {
      "size": "small",
      "round": "",
      "type": "primary"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.delOrder.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + i18n.tc("273") + " ")]) : _vm._e()], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };